import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useMotionPreference } from '../../hooks/useMotionPreference';
export const CAPTION_WORD_MS = 280;
interface CaptionLineProps {
  text: string;
  size?: 'wall' | 'compact';
  /** ms after the last word before the caption fades; null keeps it */
  fadeAfter?: number | null;
  className?: string;
}

/** Anna's spoken line — appears word by word in sync with speech, fades after 6 s. */
export function CaptionLine({
  text,
  size = 'wall',
  fadeAfter = 6000,
  className = ''
}: CaptionLineProps) {
  const reduce = useMotionPreference();
  const [visible, setVisible] = useState(true);
  const words = text.split(' ');
  useEffect(() => {
    setVisible(true);
    if (fadeAfter === null) return;
    const id = window.setTimeout(() => setVisible(false), words.length * CAPTION_WORD_MS + fadeAfter);
    return () => window.clearTimeout(id);
  }, [text, fadeAfter, words.length]);
  const sizeClass = size === 'wall' ? 'text-[32px] lg:text-[38px] leading-[1.2]' : 'text-[24px] leading-[1.25]';
  return <p aria-live="polite" className={`font-display font-light text-ink ${sizeClass} ${className}`} data-id="element-1327" data-mp="ou3wjexo1q7x">
      <AnimatePresence data-id="element-1328" data-mp="ks07fni2qn46">
        {visible && <motion.span key={text} initial="hidden" animate="show" exit={{
        opacity: 0,
        transition: {
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }
      }} variants={{
        show: {
          transition: {
            staggerChildren: CAPTION_WORD_MS / 1000
          }
        }
      }} data-id="element-1329" data-mp="kuw5rcxu3dt5">
            {words.map((word, i) => <motion.span key={`${word}-${i}`} className="mr-[0.26em] inline-block" variants={{
          hidden: {
            opacity: 0,
            y: reduce ? 0 : 6,
            filter: reduce ? 'blur(0px)' : 'blur(4px)'
          },
          show: {
            opacity: 1,
            y: 0,
            filter: 'blur(0px)',
            transition: {
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }
          }
        }} data-id="element-1330" data-mp="13r4cymaepyr3" data-mpi={i}>
                {word}
              </motion.span>)}
          </motion.span>}
      </AnimatePresence>
    </p>;
}